/** @type {import('next-i18next').UserConfig} */
const path = require('path');

module.exports = {
  i18n: {
    defaultLocale: 'en',
    locales: [
      'ar', 'de', 'en', 'es', 'fr', 'hi', 'id', 'it', 'ja', 'ko',
      'nl', 'pl', 'pt', 'ru', 'th', 'tr', 'vi', 'zh'
    ],
    // localeDetection removed for next-i18next v14+ compatibility
  },
  
  // Đường dẫn đến thư mục chứa file ngôn ngữ
  localePath: path.resolve('./public/locales'),
  
  // Namespaces used in the application
  // Các namespace tĩnh và động (được khai báo rõ ràng để đảm bảo hoạt động ở môi trường production)
  ns: [
    // Namespace tĩnh
    'common', 'features', 'howTo', 'faq', 'header', 'footer', 'hero', 'platforms', 'about', 'contact', 'copyright', 'privacy', 'terms', 'seo', 'seo-templates', 'error-report',
    
    // Các namespace động: downloader/{platform} (ví dụ: downloader/dailymotion, downloader/vk, ...)
    // Những namespace này sẽ được tự động tải nếu:
    // 1. File JSON tồn tại đúng đường dẫn public/locales/{lang}/downloader/{platform}.json
    // 2. Namespace được truyền đúng vào serverSideTranslations trong getStaticProps
    'downloader/dailymotion', 'downloader/rumble', 'downloader/odnoklassniki', 'downloader/vk', 'downloader/common',
    'downloader/facebook', 'downloader/twitter', 'downloader/instagram', 'downloader/tiktok', 'downloader/youtube',
    'downloader/pinterest', 'downloader/reddit', 'downloader/linkedin', 'downloader/soundcloud', 'downloader/spotify',
    'downloader/vimeo', 'downloader/twitch', 'downloader/snapchat', 'downloader/threads', 'downloader/imdb',
    'downloader/mashable', 'downloader/bandcamp'
  ],
  
  defaultNS: 'common',
  
  // Ngôn ngữ mặc định
  fallbackLng: 'en',
  
  // Cải thiện hiệu suất
  partialBundledLanguages: true,
  
  // Cấu hình interpolation
  interpolation: {
    escapeValue: false, // React đã tự động escape
  },
  
  // Cấu hình phát hiện ngôn ngữ đơn giản
  detection: {
    order: ['path', 'cookie', 'htmlTag', 'navigator'],
    caches: ['cookie'],
  },
  
  // Tương thích với React 18
  react: {
    useSuspense: true,
  },
  
  // Tự động tải các file ngôn ngữ trong môi trường development
  reloadOnPrerender: process.env.NODE_ENV === 'development',
};
